import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "navbar-content" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ThemeToggle = _resolveComponent("ThemeToggle")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "logo_section",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.ASSETS.MAIN_LOGO,
          alt: "logo",
          class: "unselectable"
        }, null, 8, _hoisted_3),
        _createElementVNode("h3", null, _toDisplayString(_ctx.STRINGS.CLINIC_NAME), 1)
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["hamburger unselectable", { open: _ctx.isMenuOpen }]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("span", null, null, -1),
        _createElementVNode("span", null, null, -1),
        _createElementVNode("span", null, null, -1)
      ]))], 2),
      _createElementVNode("nav", {
        ref: "navLinks",
        class: _normalizeClass(['nav-links unselectable', { open: _ctx.isMenuOpen }])
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "nav-links-gap" }, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ROUTES_ARRAY, (route) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: route.path,
            to: route.path,
            onClick: _ctx.toggleMenu
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(route.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "onClick"]))
        }), 128)),
        _createVNode(_component_ThemeToggle),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "nav-links-gap" }, null, -1))
      ], 2)
    ])
  ]))
}